import React, { version } from "react";
import { connect } from "react-redux";
import PageHeaderWrapper from "../../../components/PageHeaderWrapper";
import { Card, Button, Drawer, Form, Select, Row, Col, AutoComplete } from "antd";
import { FormUtils as GetAllFormFields } from "sz-react-utils";
import Request, { LAPI_URL } from "../../../request";
import _ from 'lodash';

const { Option } = Select;

@Form.create()
class AddBonusInvoice extends React.Component {
    state = {
        visible: true,
        invoiceType: null,
        invoiceTo: null,
        recipients: null,
        studentVisionId: null,
        dataSource: [],
    }

    onClose = () => {
        setTimeout(() => {
            this.props.onClose();
        }, 50);
    }

    handleSubmit = (e) => {
        e.preventDefault();
        let { form } = this.props;
        form.validateFieldsAndScoll((err, valData) => {
            let values = _.clone(valData);
            console.log(values);
        })
    }


    storeInvoiceType = (invoiceType) => {
        this.setState({ invoiceType });
    }

    storeInvoiceTo = async (invoiceTo) => {
        let recipients = [];

        if (invoiceTo === "Channel Partner") {
            let { data } = await Request.loadChannelPartners();
            recipients = data.reduce((temp, vv) => {
                temp.push({ _id: vv._id, display: vv.channelPartnerName });
                return temp;
            }, []);
        }
        this.setState({ invoiceTo, recipients })
    }

    onSelect = value => {
        this.setState({ studentVisionId: value });
        this.props.form.setFieldsValue({ studentVisionId: value })
    };

    handleSearch = async (value) => {
        this.setState({ studentVisionId: value });
        let dataSource = [];
        if (value.length > 3) {
            let response = await Request.handleSearchStudent({
                searchField: value,
                results: 30
            });
            if (response.data) {
                if (response.data) {
                    response.data.map((student) => {
                        dataSource.push(student.id + ' - ' + student.studentName)
                    })
                }
            }
        }
        this.setState({ dataSource });
    };

    render() {
        let { visible, invoiceType, recipients, invoiceTo } = this.state;
        let { form: { getFieldDecorator, setFieldsValue } } = this.props;
        // const inputTypes = {
        //     fields: [
        //         {
        //             label: 'Invoice Type',
        //             key: 'invoiceType',
        //             type: 'select',
        //             required: true,
        //             options: ['Bonus', 'Marketing'],
        //             onChange: v => {
        //                 setFieldsValue({ invoiceType: v }, () => {
        //                     this.storeInvoiceType(v);
        //                 });
        //             }
        //         },
        //         {
        //             label: 'Invoice For',
        //             key: 'invoiceFor',
        //             type: 'select',
        //             required: invoiceType ? true : false,
        //             hidden: !invoiceType,
        //             options: ['University', 'Channel Partner'],
        //             onChange: v => {
        //                 setFieldsValue({ invoiceFor: v }, () => {
        //                     this.storeInvoiceFor(v);
        //                 })
        //             }
        //         },
        //         {
        //             label: `${invoiceFor}`,
        //             key: 'recipient',
        //             required: invoiceFor ? true : false,
        //             type: 'select',
        //             options: recipients,
        //             showSearch: true,
        //             hidden: !invoiceFor,
        //             onChange: recipient => {
        //                 setFieldsValue({ recipient });
        //             }
        //         }
        //     ]
        // };
        return (
            <Drawer
                title="Generate Invoice"
                placement="right"
                closable={true}
                onClose={this.onClose}
                width={500}
                visible={visible}>
                <Card bordered={true}>
                    <Form onSubmit={this.handleSubmit}>
                        <Row>
                            <Col span={6}>
                                <div>
                                    Invoice Type:
                                </div>
                            </Col>
                            <Col span={18}>
                                <Select value={invoiceType} onChange={(v) => this.storeInvoiceType(v)} placeholder="Invoice Type" required>
                                    <Option value="Bonus">Bonus</Option>
                                    <Option value="Marketing">Marketing</Option>
                                </Select>
                            </Col>

                        </Row>

                        {
                            invoiceType ?
                                <Row>
                                    <Col span={6}>
                                        <div>
                                            Invoice To:
                                        </div>
                                    </Col>
                                    <Col span={18}>
                                        <Select value={invoiceTo} onChange={(v) => this.storeInvoiceTo(v)} placeholder="Invoice To" required>
                                            <Option value="University">University</Option>
                                            <Option value="Channel Partner">Channel Partner</Option>
                                        </Select>
                                    </Col>

                                </Row>

                                : null
                        }


                        {
                            invoiceType === "Bonus" ?
                                <Row style={{ marginTop: 10, marginBottom: 10 }}>
                                    <Col span={8} ><label htmlFor="studentVisionId" className="ant-form-item-required" title="Related Vision ID">Related Vision ID</label></Col>
                                    <Col span={16}>
                                        <AutoComplete
                                            value={this.state.studentVisionId}
                                            dataSource={this.state.dataSource}
                                            style={{ width: 289 }}
                                            onSelect={this.onSelect}
                                            onSearch={this.handleSearch}
                                        />
                                    </Col>
                                </Row>
                                : null
                        }
                        {/* <GetAllFormFields
                            inputSchema={inputTypes}
                            apiurl={LAPI_URL}
                            getFieldDecorator={getFieldDecorator}
                        /> */}
                    </Form>
                </Card>
            </Drawer>
        )
    }
}


class BonusInvoices extends React.Component {
    state = {
        total: 0,
        showAddInvoiceDrawer: false
    }

    constructor(props) {
        super(props);
        this.table = React.createRef();
    }

    showAddInvoice = () => {
        this.setState({ showAddInvoiceDrawer: true });
    }

    hideAddInvoice = () => {
        this.setState({ showAddInvoiceDrawer: false }, () => {
            this.table.current.reload();
        });
    }

    render() {
        let { total, showAddInvoiceDrawer } = this.state;
        return (
            <PageHeaderWrapper title={`Bonus/Marketing Invoices: ${total}`}>
                {
                    showAddInvoiceDrawer ?
                        <AddBonusInvoice onClose={this.hideAddInvoice} />
                        : null
                }
                <Card bordered={true}>
                    <Button type='primary' icon="plus" style={{ float: 'right' }} onClick={this.showAddInvoice} />
                </Card>
            </PageHeaderWrapper>
        )

    }
}


const mapStateToProps = ({ global, router }) => ({
    categories: global.categories,
    search: router.location.search,
    location: router.location,
});

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch,
    };
};
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BonusInvoices);